export default [
  {
    path: '/',
    redirect: 'home',
    component:() => import('@/views/home'),
  },
  {
    path: '/home',
    name: 'home',
    component:() => import('@/views/home'),
    meta:{
      title:'首页'
    },
  },
  {
    path: '/homeDetail',
    name: 'homeDetail',
    component:() => import('@/views/homeDetail'),
    meta:{
      title:'园区详情'
    },
  },
  {
    path: '/nengrenku',
    name: 'nengrenku',
    component:() => import('@/views/nengrenku'),
    meta:{
      title:'能人库'
    },
  },
  {
    path: '/nengrenkuList',
    name: 'nengrenkuList',
    component:() => import('@/views/nengrenkuList'),
    meta:{
      title:'能人库列表'
    },
  },
    {
      path: '/rencaiku',
      name: 'rencaiku',
      component:() => import('@/views/rencaiku'),
      meta:{
        title:'人才库'
      },
  },
  {
    path: '/rencaikuList',
    name: 'rencaikuList',
    component:() => import('@/views/rencaikuList'),
    meta:{
      title:'人才库'
    },
  },
  {
    path: '/zhuanjiaku',
    name: 'zhuanjiaku',
    component:() => import('@/views/zhuanjiaku'),
    meta:{
      title:'专家库'
    },
  },
  {
    path: '/zhuanjiakuList',
    name: 'zhuanjiakuList',
    component:() => import('@/views/zhuanjiakuList'),
    meta:{
      title:'专家库'
    },
  },
  {
    path: '/weifanxiang',
    name: 'weifanxiang',
    component:() => import('@/views/weifanxiang'),
    meta:{
      title:'未能返乡能人'
    },
  },
  {
    path: '/weifanxiangList',
    name: 'weifanxiangList',
    component:() => import('@/views/weifanxiangList'),
    meta:{
      title:'未能返乡能人'
    },
  },
  {
    path: '/xiangmuku',
    name: 'xiangmuku',
    component:() => import('@/views/xiangmuku'),
    meta:{
      title:'项目库'
    },
  },
  {
    path: '/xiangmukuList',
    name: 'xiangmukuList',
    component:() => import('@/views/xiangmukuList'),
    meta:{
      title:'项目库'
    },
  },
  {
    path: '/ziyuanku',
    name: 'ziyuanku',
    component:() => import('@/views/ziyuanku'),
    meta:{
      title:'资源库'
    },
  },
  {
    path: '/ziyuankuList',
    name: 'ziyuankuList',
    component:() => import('@/views/ziyuankuList'),
    meta:{
      title:'资源库'
    },
  },
  {
    path: '/zhengcexinxi',
    name: 'zhengcexinxi',
    component:() => import('@/views/zhengcexinxi'),
    meta:{
      title:'政策信息'
    },
  },
  {
    path: '/xiangcunyuanqu',
    name: 'xiangcunyuanqu',
    component:() => import('@/views/xiangcunyuanqu'),
    meta:{
      title:'乡村园区'
    },
  },
  {
    path: '/xiangcunyuanquDetail',
    name: 'xiangcunyuanquDetail',
    component:() => import('@/views/xiangcunyuanquDetail'),
    meta:{
      title:'乡村园区'
    },
  },
  {
    path: '/xinnongxie',
    name: 'xinnongxie',
    component:() => import('@/views/xinnongxie'),
    meta:{
      title:'新农协',
      keepAlive: true
    },
  },
  {
    path: '/xinnongxieDetail',
    name: 'xinnongxieDetail',
    component:() => import('@/views/xinnongxieDetail'),
    meta:{
      title:'新农协'
    },
  },
  {
    path: '/data',
    name: 'data',
    component:() => import('@/views/data'),
    meta:{
      title:'数据统计'
    },
  },
  // {
  //   path: '/login',
  //   name: 'login',
  //   component:() => import('@/views/login'),
  //   meta:{
  //     title:'登录'
  //   },
  // }

]



// WEBPACK FOOTER //
// ./src/router/routes.js